
/* RRR standalone Quick Buy v3 — collection and search page.
   Event delegation survives AJAX filters/sorting/pagination.
   Does not modify main RRR catalog JS or the product detail page. */
(function () {
  'use strict';
  if (window.__RRRQuickBuyV3) return;
  window.__RRRQuickBuyV3 = true;

  var overlay = null;
  var opener = null;
  var product = null;
  var variant = null;
  var isAdding = false;
  var previousOverflow = '';
  var openSequence = 0;
  var closeIcon = '<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="1.7" fill="none" stroke-linecap="round"><path d="M5 5l14 14M19 5 5 19"/></svg>';
  var escapeHTML = function (value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  };
  var money = function (cents) {
    return new Intl.NumberFormat('en-IN', {style:'currency', currency:'INR', maximumFractionDigits:2}).format(cents/100);
  };
  function ensure() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'rrr-quickbuy-backdrop';
    overlay.hidden = true;
    overlay.innerHTML = '<div class="rrr-quickbuy-box" role="dialog" aria-modal="true" aria-label="Quick Buy"><button type="button" class="rrr-quickbuy-close" aria-label="Close Quick Buy">' + closeIcon + '</button><div class="rrr-quickbuy-content"></div></div>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay || event.target.closest('.rrr-quickbuy-close')) { close(); return; }
      var chip = event.target.closest('[data-rrr-variant-id]');
      if (chip && product) {
        var selected = product.variants.find(function (v) {return String(v.id) === chip.dataset.rrrVariantId;});
        if (selected && selected.available) {variant = selected; updateVariant();}
        return;
      }
      var qtyButton = event.target.closest('[data-rrr-qty-delta]');
      if (qtyButton) {
        var input = overlay.querySelector('.rrr-quickbuy-qty');
        if (input) {
          var next = (parseInt(input.value, 10) || 1) + Number(qtyButton.dataset.rrrQtyDelta);
          input.value = String(Math.max(1, Math.min(99, next)));
        }
        return;
      }
      if (event.target.closest('.rrr-quickbuy-submit')) addToCart();
    });
    overlay.addEventListener('change', function (event) {
      if (event.target.matches('.rrr-quickbuy-select') && product) {
        variant = product.variants.find(function (v) {return String(v.id) === event.target.value;});
        updateVariant();
      }
      if (event.target.matches('.rrr-quickbuy-qty')) {
        event.target.value = String(Math.max(1, Math.min(99, parseInt(event.target.value, 10) || 1)));
      }
    });
  }
  function close() {
    openSequence++;
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    document.body.style.overflow = previousOverflow;
    if (opener && opener.isConnected) opener.focus({preventScroll:true});
  }
  function updateVariant() {
    if (!overlay || !variant) return;
    var priceNode = overlay.querySelector('.rrr-quickbuy-price');
    var button = overlay.querySelector('.rrr-quickbuy-submit');
    if (!priceNode || !button) return;
    var price = variant.price;
    var compare = variant.compare_at_price;
    priceNode.innerHTML = '<strong>' + money(price) + '</strong>' +
      (compare > price ? '<s>' + money(compare) + '</s><span>' + Math.round((compare-price)*100/compare) + '% OFF</span>' : '');
    var chips = overlay.querySelectorAll('[data-rrr-variant-id]');
    chips.forEach(function (chip) {
      chip.setAttribute('aria-pressed', String(String(variant.id) === chip.dataset.rrrVariantId));
    });
    button.disabled = isAdding || !variant.available;
    button.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
  }
  function render(p, productUrl) {
    if (!p.variants || !p.variants.length) throw new Error('No variants available');
    product = p;
    variant = p.variants.find(function (v) {return v.available;}) || p.variants[0];
    var imageUrl = p.featured_image || (p.images && p.images[0]) || '';
    var image = imageUrl ? '<img src="' + escapeHTML(imageUrl) + '" loading="lazy" alt="' + escapeHTML(p.title) + '">' : '';
    var top = '<div class="rrr-quickbuy-top">' + image + '<div><h2 class="rrr-quickbuy-title">' + escapeHTML(p.title) + '</h2><div class="rrr-quickbuy-price"></div></div></div>';
    var isSizes = p.options && p.options.length === 1 &&
      String(typeof p.options[0] === 'string' ? p.options[0] : p.options[0].name).toLowerCase() === 'size';
    var optionsMarkup;
    if (isSizes) {
      optionsMarkup = '<div class="rrr-quickbuy-label">Select Size</div><div class="rrr-quickbuy-variants" role="group" aria-label="Select Size">';
      p.variants.forEach(function (v) {
        var label = v.option1 || v.public_title || v.title;
        optionsMarkup += '<button type="button" class="rrr-quickbuy-chip" data-rrr-variant-id="' + v.id +
          '" aria-pressed="' + String(v.id === variant.id) + '" ' + (v.available ? '' : 'disabled ') +
          'title="' + escapeHTML(label + (v.available ? '' : ' — Sold out')) + '">' + escapeHTML(label) + '</button>';
      });
      optionsMarkup += '</div>';
    } else {
      var options = p.variants.map(function (v) {
        return '<option value="' + v.id + '" ' + (v.id === variant.id ? 'selected ' : '') +
          (v.available ? '' : 'disabled ') + '>' +
          escapeHTML(v.public_title || v.title) + (v.available ? '' : ' — Sold out') + '</option>';
      }).join('');
      optionsMarkup = '<label for="rrr-quickbuy-variant" class="rrr-quickbuy-label">Choose Options</label>' +
        '<select id="rrr-quickbuy-variant" class="rrr-quickbuy-select">' + options + '</select>';
    }
    var quantity = '<div class="rrr-quickbuy-quantity"><button type="button" data-rrr-qty-delta="-1" aria-label="Decrease quantity">−</button>' +
      '<input class="rrr-quickbuy-qty" type="number" min="1" max="99" value="1" inputmode="numeric" aria-label="Quantity">' +
      '<button type="button" data-rrr-qty-delta="1" aria-label="Increase quantity">+</button></div>';
    var footer = '<div class="rrr-quickbuy-actions">' + quantity +
      '<button type="button" class="rrr-quickbuy-submit">Add to Cart</button></div>' +
      '<p class="rrr-quickbuy-error" role="alert" hidden></p>' +
      '<a href="' + escapeHTML(productUrl) + '" class="rrr-quickbuy-full">View full product details →</a>';
    overlay.querySelector('.rrr-quickbuy-content').innerHTML =
      top + '<div class="rrr-quickbuy-divider"></div>' + optionsMarkup + footer;
    updateVariant();
  }
  async function open(button) {
    if (isAdding) return;
    ensure();
    opener = button;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    overlay.hidden = false;
    overlay.querySelector('.rrr-quickbuy-content').innerHTML = '<p role="status">Loading product options…</p>';
    overlay.querySelector('.rrr-quickbuy-close').focus({preventScroll:true});
    var id = ++openSequence;
    var productUrl = button.getAttribute('data-rrr-quick-buy');
    try {
      var url = new URL(productUrl, window.location.href);
      var response = await fetch(url.origin + url.pathname.replace(/\/$/, '') + '.js', {headers:{'Accept':'application/json'}});
      if (!response.ok) throw new Error('Could not load product');
      var data = await response.json();
      if (overlay.hidden || id !== openSequence) return;
      render(data, productUrl);
    } catch (error) {
      if (overlay.hidden || id !== openSequence) return;
      overlay.querySelector('.rrr-quickbuy-content').innerHTML =
        '<p role="alert">Quick Buy is temporarily unavailable.</p><a class="rrr-quickbuy-full" href="' +
        escapeHTML(productUrl) + '">View product details →</a>';
    }
  }
  async function addToCart() {
    if (isAdding || !variant || !variant.available) return;
    isAdding = true;
    var submit = overlay.querySelector('.rrr-quickbuy-submit');
    var error = overlay.querySelector('.rrr-quickbuy-error');
    submit.disabled = true;
    submit.textContent = 'Adding…';
    error.hidden = true;
    try {
      var cart = document.querySelector('cart-drawer');
      var requestedSections = cart && typeof cart.getSectionsToRender === 'function' ?
        cart.getSectionsToRender().map(function (section) {return section.id;}) : ['cart-drawer', 'cart-icon-bubble'];
      var form = new FormData();
      form.append('id', String(variant.id));
      form.append('quantity', String(Math.max(1, Math.min(99, parseInt(overlay.querySelector('.rrr-quickbuy-qty').value,10)||1))));
      form.append('sections', requestedSections.join(','));
      form.append('sections_url', window.location.pathname);
      var response = await fetch(window.routes && window.routes.cart_add_url || '/cart/add.js', {
        method:'POST', headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},body:form
      });
      var result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Cart update failed');
      var variantId = String(variant.id);
      close();
      if (cart && typeof cart.renderContents === 'function' && result.sections) {
        cart.renderContents(result);
      } else if (cart && typeof cart.open === 'function') {
        cart.open();
      }
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {source:'rrr-quickbuy', cartData:result, productVariantId:variantId});
      }
    } catch (errorMessage) {
      error.textContent = errorMessage.message || 'Please try again';
      error.hidden = false;
    } finally {
      isAdding = false;
      if (submit.isConnected) {
        submit.disabled = !variant || !variant.available;
        submit.textContent = variant && variant.available ? 'Add to Cart' : 'Sold Out';
      }
    }
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rrr-quick-buy]');
    if (!button) return;
    event.preventDefault();
    open(button);
  });
  document.addEventListener('keydown', function (event) {
    if (!overlay || overlay.hidden) return;
    if (event.key === 'Escape') {event.preventDefault();close();return;}
    if (event.key !== 'Tab') return;
    var focusable = Array.from(overlay.querySelectorAll('button:not(:disabled),select,input,a[href]')).filter(function (element) {
      return element.getClientRects().length > 0;
    });
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length-1];
    if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
  });
})();
